import { render } from "./BlockRelated.vue?vue&type=template&id=e8e82cba"
import script from "./BlockRelated.vue?vue&type=script&lang=js"
export * from "./BlockRelated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockRelated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8e82cba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8e82cba', __exports__)) {
    console.log('reload')
    api.reload('e8e82cba', __exports__)
  }
  
  module.hot.accept("./BlockRelated.vue?vue&type=template&id=e8e82cba", () => {
    console.log('re-render')
    api.rerender('e8e82cba', render)
  })

}


export default __exports__